import {defineStore} from 'pinia'
import {http} from '@/extensions/http'
import API_ENDPOINTS from '@/config/API_ENDPOINTS.ts'
import i18n from '@/i18n'

export const useChairStore = defineStore('chair', {
    state: (): { chair: Record<locale, Chair | undefined> } => ({
        chair: {
            en: undefined,
            fr: undefined
        }
    }),
    actions: {
        async get() {
            const locale: locale = i18n.global.locale.value

            if (!this.chair[locale]) {
                const {data} = await http.get<Chair>(API_ENDPOINTS.CHAIR.SHOW.replace(':chair', import.meta.env.VITE_APP_CHAIR_ID))

                this.chair[locale] = data
            }

            return this.chair[locale]
        }
    }
})
